import { render, staticRenderFns } from "./model-multi-taggable.vue?vue&type=template&id=4071dab7&scoped=true&"
import script from "./model-multi-taggable.vue?vue&type=script&lang=js&"
export * from "./model-multi-taggable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4071dab7",
  null
  
)

export default component.exports